
export default {
  name: 'DiscountBanner',
  props: {
    DiscountBannerLang: {
      type: String,
      required: false,
    },
    DiscountBannerURL: {
      type: String,
      required: true,
    },
    DiscountBannerImg: {
      type: String,
      required: true,
    },
    DiscountBannerClass: {
      type: String,
      required: false,
    },
  },
  data() {
    return {}
  },
}
